/**
 * Inicijali za krug umjesto slike — prvo slovo prve i zadnje riječi.
 *
 * Korisnici u sustavu nemaju sliku, pa je ovo jedini prikaz osobe koji nosi informaciju.
 * Iz istog razloga služi i firmi kad tenant nema postavljen logotip.
 */
export const getInitials = (fullName: string): string => {
  const words = (fullName ?? "").trim().split(/\s+/).filter(Boolean);

  if (!words.length) return "";

  const first = words[0].charAt(0);
  // Srednja imena se preskaču — inicijali su prezimenu bliži nego drugom imenu.
  const last = words.length > 1 ? words[words.length - 1].charAt(0) : "";

  return `${first}${last}`.toUpperCase();
};
